/* eslint-disable */
export default function() {
  document.addEventListener('turbo:load', () => {
    // cleanup global space
    document.querySelector('html').removeAttribute('data-uw-w-loader');
    delete window._userway;
    delete window.UserWay;
    delete window.UserWayWidgetApp;

    (function(d){var s = d.createElement("script");s.setAttribute("data-account", "J2Pvt9fj9r");s.setAttribute("src", "https://cdn.userway.org/widget.js");(d.body || d.head).appendChild(s);})(document);
  });
};
